import { render, staticRenderFns } from "./partnersTab.vue?vue&type=template&id=bb9f5294&scoped=true&lang=pug"
import script from "./partnersTab.vue?vue&type=script&lang=js"
export * from "./partnersTab.vue?vue&type=script&lang=js"
import style0 from "./partnersTab.vue?vue&type=style&index=0&id=bb9f5294&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb9f5294",
  null
  
)

export default component.exports